import LOGO from "../images/Aliados.png";

export const Team__Aliados = {
  name: "Aliados",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#1E3A8A",
  teamJerseyColor: "#111111",

  // Stats
  gamesWon: 1,
  gamesLost: 2,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 47 + 53 + 58,
  goalsScoredAgainst: 56 + 67 + 50,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
